export default __webpack_public_path__ + "static/media/categories.81a157d1.png";